import script from "./ImportCMMSubmissionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportCMMSubmissionPage.vue?vue&type=script&setup=true&lang=js"

import "./ImportCMMSubmissionPage.vue?vue&type=style&index=0&id=79f19597&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f19597"]])

export default __exports__